import { motion } from "framer-motion";
import { EASE } from "./Reveal";

export const PageTransition = ({ children }) => (
  <motion.main
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -16 }}
    transition={{ duration: 0.6, ease: EASE }}
  >
    {children}
  </motion.main>
);
